import React, { useRef, useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import { useNavigate } from 'react-router-dom';
import { state } from '../../store/global';
import API from '../../lib/api';
import findMessage from '../../utils/messages'; // Helper function defined below

import LoginRightWrapper from '../../components/common/LoginRightWrapper';
import LoginLeftSide from '../../components/common/LoginLeftSide';
import LoginFooter from '../../components/common/LoginFooter';
import NormalButton from '../../components/common/NormalButton';
import PhoneNumberInputbox from '../../components/common/PhoneNumberInputbox';
import Notification from '../../components/common/Notification';
import { useForceLightTheme } from '../../lib/theme';

export default function LoginPhoneSet() {
  useForceLightTheme();

  const snap = useSnapshot(state);
  const navigate = useNavigate();

  useEffect(() => {
    setPhonenumber({
      nationality: {
        country: snap.user.phonenumber.nationality.country || 'Colombia',
        areaCode: snap.user.phonenumber.nationality.area_code || '+57',
        flag: '',
      },
      number: snap.user.phonenumber.number || '',
    });
  }, [snap.user.phonenumber]);

  const [phonenumber, setPhonenumber] = useState({
    nationality: {
      country: '',
      areaCode: '',
      flag: '',
    },
    number: '',
  });
  const [notification, setNotification] = useState(null);

  const onChangePhonenumber = (type, value) => {
    let newPhone = phonenumber;
    newPhone[type] = value;
    setPhonenumber(newPhone);
  };

  const onPhoneVerify = async () => {
    // Call API here
    await API.post('auth/sendCodeToPhone', {
      phonenumber: phonenumber.nationality.areaCode + phonenumber.number,
    })
      .then(() => {
        navigate('/login/phoneVerify');
      })
      .catch((err) => {
        console.log('err: ', err);
        setNotification({
          message: findMessage('Invalid phonenumber'),
          type: 'error',
        });
      });
  };
  const onGoToPage = (path) => {
    navigate(path);
  };

  return (
    <div className="relative flex min-h-screen">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        {/* Modal content with exact size */}
        <div className="relative z-10 bg-white rounded-2xl shadow-xl w-[1044px] h-[700px] overflow-hidden">
          <div className="flex flex-col md:flex-row w-full h-full">
            {/* Left Side - Image */}
            <LoginLeftSide />

            {/* Right Side - Form */}
            <div className="w-full h-full flex flex-col justify-between md:w-1/2 p-10 bg-[#F9F9F9]">
              <LoginRightWrapper onGoToPage={(path) => onGoToPage(path)} />

              <div>
                <div className="h-full space-y-6 font-[poppins] font-semibold pl-0 pr-0 md:pl-14 md:pr-14">
                  <div className="space-y-4">
                    <h2 className="text-xl text-[#333333] font-bold leading-[20px] tracking-[0%]">
                      Activar verificación de dos pasos
                    </h2>
                    <div className="space-y-5 text-sm text-[#717680] font-normal leading-[20px] tracking-[0%]">
                      <h3>
                        Para mantener tu cuenta segura, usaremos la validación
                        en dos pasos.
                      </h3>
                      <h3>
                        Te enviaremos un código por SMS cada vez que inicies
                        sesión.
                      </h3>
                      <h3>Confirma que tu teléfono es el siguiente</h3>
                    </div>
                  </div>

                  <PhoneNumberInputbox
                    disabled={true}
                    phonenumber={phonenumber}
                    onChange={(type, value) => onChangePhonenumber(type, value)}
                  />

                  <div className="space-y-2">
                    <NormalButton
                      customClass="w-full bg-[#092F7B] text-white"
                      text="Confirmar y enviar código"
                      onClick={onPhoneVerify}
                    />

                    <NormalButton
                      customClass="w-full bg-[#FDFDFD] text-[#092F7B] border border-[#092F7B]"
                      text="Modificar número de teléfono"
                      onClick={() => navigate('/login/updatePhone')}
                    />
                  </div>
                </div>
              </div>

              {/* Login footer */}
              <LoginFooter onClick={() => navigate('/contact')} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
